import { MergeFormConfig } from "@/types/merge";

/**
 * Generates Supabase select fields string from a merge configuration
 * Includes all fields defined in the config plus essential system fields
 */
export function generateSelectFieldsFromConfig<T>(config: MergeFormConfig<T>): string {
    // Essential system fields that should always be included
    const systemFields = ["id", "created_at"];
    
    // Get field names from the configuration
    const configFields = config.fields.map(field => field.name);
    
    // Combine and deduplicate
    const allFields = [...new Set([...systemFields, ...configFields])];
    
    // Remove excluded fields but keep system fields
    const finalFields = allFields.filter(field => 
        systemFields.includes(field) || !config.excludeFields?.includes(field)
    );
    
    return finalFields.join(", ");
}

/**
 * Validates that all required fields for merge are available in the fetched data
 */
export function validateFetchedDataForMerge<T>(
	data: T[],
	config: MergeFormConfig<T>
): { isValid: boolean; missingFields: string[] } {
	if (!data.length) {
		return { isValid: true, missingFields: [] };
	}
	
	const firstItem = data[0] as any;
	const availableFields = Object.keys(firstItem);
	const requiredFields = config.fields
		.filter(field => field.required)
		.map(field => field.name);
	
	const missingFields = requiredFields.filter(field => 
		!availableFields.includes(field)
	);
	
	return {
		isValid: missingFields.length === 0,
		missingFields
	};
}
